import { render, staticRenderFns } from "./PromoCard.vue?vue&type=template&id=b7d9020a&scoped=true"
import script from "./PromoCard.vue?vue&type=script&lang=js"
export * from "./PromoCard.vue?vue&type=script&lang=js"
import style0 from "./PromoCard.vue?vue&type=style&index=0&id=b7d9020a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d9020a",
  null
  
)

export default component.exports